'use strict';

(function () {
  var toggleZoom = function () {
    $('.header').on('click', '.accessibility-zoom', function () {
      toggleOption('_zoom');
      setAcessibilityOption('_zoom');
    });
  };

  var toggleContrast = function () {
    $('.header').on('click', '.accessibility-contrast', function () {
      toggleOption('_contrast');
      setAcessibilityOption('_contrast');
    });
  };

  var toggleInvertColor = function () {
    $('.header').on('click', '.accessibility-invert', function () {
      toggleOption('_invert');
      setAcessibilityOption('_invert');
    });
  };

  var toggleBold = function () {
    $('.header').on('click', '.accessibility-bold', function () {
      toggleOption('_bold');
      setAcessibilityOption('_bold');
    });
  };

  var toggleHandtalk = function () {
    $('.header').on('click', '.accessibility-handtalk', function () {
      if (!getOptionFromLocalstorage('_handtalk')) {
        turnHandTalkOn();
      } else {
        window.location.reload();
      }
      setAcessibilityOption('_handtalk');
    });
  };

  var turnHandTalkOn = function () {
    toggleOption('_handtalk');
    setHandTalkScript(function () {
      new window.HT(blz.globals.handTalk);
    });
  };

  var setHandTalkScript = function (_callback) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//plugin.handtalk.me/web/latest/handtalk.min.js';
    s.onload = _callback;
    document.getElementsByTagName('body')[0].appendChild(s);
  };

  var toggleOption = function (option) {
    document.getElementsByTagName('html')[0].classList.toggle(option);
    var toggleEle = document.querySelector('.accessibility' + option.replace('_', '-'));
    toggleEle && toggleEle.classList.toggle('accessibility-checked');
  };

  var setAcessibilityOption = function (option) {
    'localStorage' in window && localStorage.setItem(option, !getOptionFromLocalstorage(option));
  };

  var getOptionFromLocalstorage = function (option) {
    return 'localStorage' in window && window.localStorage.getItem(option) == 'true';
  };

  $(function () {
    getOptionFromLocalstorage('_zoom') && toggleOption('_zoom');
    getOptionFromLocalstorage('_contrast') && toggleOption('_contrast');
    getOptionFromLocalstorage('_invert') && toggleOption('_invert');
    getOptionFromLocalstorage('_bold') && toggleOption('_bold');
    getOptionFromLocalstorage('_handtalk') && turnHandTalkOn();

    toggleContrast();
    toggleHandtalk();
    toggleZoom();
    toggleInvertColor();
    toggleBold();
  });
})();
